import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SigepeMainLayoutModule } from '@sigepe/sigepe-template';
import { LogLevel, SegurancaConfiguration, SigepeSegurancaModule, AuthInterceptor } from '@sigepe/ngx-sigepe-seguranca';
import { environment } from 'src/environments/environment';

export const SEGURANCA_CONFIG: SegurancaConfiguration = {
    loginUnicoHost: environment.loginUnicoHost,
    jwksHost: environment.jwksHost,
    apiSigepeHost: environment.apiSigepeHost,
    redirectUrl: `${window.location.protocol}//${window.location.host}/autorizacao`,
    postLogoutRedirectUri: `${window.location.protocol}//${window.location.host}`,
    cookieDomain: environment.cookieDomain,
    clientId: environment.clientId,
    scope: 'openid+email+phone+profile+govbr_confiabilidades', // scopes do AcessoGOV
    sistemaOrigem: environment.sistemaOrigem, // Tag cadastrada no Autoriza
    responseType: 'code',
    silentRenew: false,
    renewTimeBeforeTokenExpiresInSeconds: 10,
    logLevel: environment.production ? LogLevel.None : LogLevel.Error,
    secureRoutes: ['/api/', environment.footerUrl, environment.menuUrl, environment.mensageriaUrl, environment.manualUrl, environment.loginUnicoHost, environment.apiSigepeHost, environment.apiSigepeURL, environment.barramentoServicoFerias, ...('menuUrlRoot' in environment && typeof environment.menuUrlRoot === 'string' ? [environment.menuUrlRoot] : [])]
};

@NgModule({
    declarations: [],
    imports: [CommonModule, SigepeMainLayoutModule.forRoot(environment), SigepeSegurancaModule.forRoot(SEGURANCA_CONFIG)],
    // providers: [
    //   { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    // ],
    exports: [SigepeMainLayoutModule, SigepeSegurancaModule]
})
export class SigepeModule {}
